"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = void 0;
var OrderArticle_1 = require("./OrderArticle");
var Order = /** @class */ (function () {
    function Order(params) {
        var _a;
        this.ptOrderId = params.ptOrderId;
        this.sourceOrderId = params.sourceOrderId;
        this.shipping = params.shipping;
        this.articleGames = params.articleGames;
        this.articleCategories = params.articleCategories;
        this.state = params.state;
        this.source = params.source;
        this.articlesCount = params.articlesCount;
        this.totalValue = params.totalValue;
        this.articleValue = params.articleValue;
        this.buyer = params.buyer;
        this.issues = params.issues;
        this.isCtZero = params.isCtZero;
        this.isCtZeroClosing = params.isCtZeroClosing;
        this.isPresale = params.isPresale;
        this.currency = params.currency;
        this.picking = params.picking;
        this.articles = ((_a = params.articles) !== null && _a !== void 0 ? _a : []).map(function (a) {
            return a instanceof OrderArticle_1.OrderArticle ? a : new OrderArticle_1.OrderArticle(a);
        });
        this.updatedAt = params.updatedAt;
        this.note = params.note;
    }
    Order.prototype.copy = function () {
        return new Order(__assign(__assign({}, this.toPlainObject()), { articles: this.articles ? this.articles.map(function (art) { return new OrderArticle_1.OrderArticle(art); }) : [] }));
    };
    Order.prototype.toPlainObject = function () {
        var _a;
        return {
            ptOrderId: this.ptOrderId,
            sourceOrderId: this.sourceOrderId,
            shipping: __assign({}, this.shipping),
            articleGames: __spreadArray([], this.articleGames, true),
            articleCategories: __spreadArray([], this.articleCategories, true),
            state: __assign({}, this.state),
            source: this.source,
            articlesCount: this.articlesCount,
            totalValue: this.totalValue,
            articleValue: this.articleValue,
            buyer: __assign({}, this.buyer),
            issues: this.issues ? this.issues.map(function (i) { return (__assign({}, i)); }) : undefined,
            isCtZero: this.isCtZero,
            isCtZeroClosing: this.isCtZeroClosing,
            isPresale: this.isPresale,
            currency: this.currency,
            picking: this.picking ? __assign({}, this.picking) : undefined,
            articles: this.articles ? (_a = this.articles) === null || _a === void 0 ? void 0 : _a.map(function (a) { return a.toPlainObject(); }) : [],
            updatedAt: this.updatedAt,
            note: this.note,
        };
    };
    return Order;
}());
exports.Order = Order;
//# sourceMappingURL=Order.js.map